<template>
    <div :class="[$style.options, clipped ? $style.clipped : '']"
         :style="bounds">
         <div :class="$style.checkable">
        <GnzsCheckbox
            :value="isAllChecked || isSomeChecked"
            :class="$style.optionsChecker"
            :isSomeChecked="isSomeChecked"
            @input="setCheckedAll"
        >
        </GnzsCheckbox>
        </div>
        <ul :class="$style.list">
            <li @click="moveUp"
                :class="[$style.list_item]"
            ><svg :class="[$style.icon, $style.icon_arrow]"><use xlink:href="#gnzs-1c-icon__arrow-up"></use></svg></li>
            <li @click="moveDown"
                :class="[$style.list_item]"
            ><svg :class="[$style.icon, $style.icon_arrow]"><use xlink:href="#gnzs-1c-icon__arrow-down"></use></svg></li>
            <li v-if="defaults.isPartialRealizationEnabled && tariffFeatures.includes('partial-realization')" 
                @click="addRealization" 
                :class="[$style.list_item, $style.list_item_standart]"
            ><svg :class="[$style.icon, $style.icon_shipment]"><use xlink:href="#gnzs-1c-icon__shipment"></use></svg>Создать реализацию</li>
            <li v-if="defaults.isInvoicesEnabled && tariffFeatures.includes('partial-invoices')"
                @click="addInvoice"
                :class="[$style.list_item, $style.list_item_standart]"
            ><svg :class="[$style.icon, $style.icon_invoice]"><use xlink:href="#gnzs-1c-icon__invoice"></use></svg>Создать счет</li>
            <li v-if="defaults.stockWorktype == 1" 
                @click="addStock" 
                :class="[$style.list_item, $style.list_item_standart]"
            ><svg :class="[$style.icon, $style.icon_store]"><use xlink:href="#gnzs-1c-icon__store"></use></svg>Применить склад</li>
            <li v-if="tariffFeatures.includes('provisions') && defaults.isProvisionEnabled" 
                @click="addProvision" 
                :class="[$style.list_item, $style.list_item_standart]"
            ><svg :class="[$style.icon, $style.icon_provision]"><use xlink:href="#gnzs-1c-icon__list"></use></svg>Применить обеспечение</li>
            <li @click="addPricetype" 
                :class="[$style.list_item, $style.list_item_standart]"
            ><svg :class="[$style.icon, $style.icon_pricetype]"><use xlink:href="#gnzs-1c-icon__pricetype"></use></svg>Применить тип цены</li>
            <li @click="addDiscount" 
                :class="[$style.list_item, $style.list_item_standart]"
            ><svg :class="[$style.icon, $style.icon_discount]"><use xlink:href="#gnzs-1c-icon__percent"></use></svg>Применить скидку</li>
            <li @click="remove" 
                :class="[$style.list_item, $style.list_item_standart]"
            ><svg :class="$style.icon_delete"><use xlink:href="#gnzs-1c-icon__delete"></use></svg>Удалить</li>
        </ul>
    </div>
</template>

<script>
import GnzsCheckbox from '@/gnzs-controls/Checkbox';

import {mapActions, mapGetters} from 'vuex';
import openProvisionModal from './../Modals/AddProvisionModal';
import openDiscountModal from './../Modals/AddDiscountModal';
import openPricetypeModal from './../Modals/AddPricetypeModal';
import openStockModal from './../Modals/AddStockModal';
import {openConfirmModal} from '@/gnzs-controls/Modal/modal.utils';

export default {
    props: {
        bounds: {
            type: Object
        },
        clipped: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            someChecked: 'order/someChecked',
            isAllChecked: 'order/isAllChecked',
            isSomeChecked: 'order/isSomeChecked',
            defaults: 'settings/defaults',
            tariffFeatures: 'features/getFeatures',
            confirmData: 'localSettings/confirmRemoveProducts'
        })
    },
    methods: {
        ...mapActions({
            moveUp: 'order/moveUp',
            moveDown: 'order/moveDown',
            removeProducts: 'order/removeProducts',
            setCheckedAll: 'order/setCheckedAll',
            newRealization: 'realizations/newItem',
            newInvoice: 'invoices/newItem',
            setTabMode: 'order/setTabMode',
            calcOrder: 'order/calcOrder'
        }),
        addRealization(){
            this.newRealization()
            this.setCheckedAll(false)
            this.setTabMode('1')
        },
        addInvoice(){
            this.newInvoice()
            this.setCheckedAll(false)
            this.setTabMode('3')
        },
        addProvision(){
            openProvisionModal()
        },
        addPricetype(){
            openPricetypeModal()
        },
        addDiscount(){
            openDiscountModal()
        },
        addStock(){
            openStockModal()
        },
        remove(){
            openConfirmModal({
                ...this.confirmData,
                onAccept: () => {
                    this.removeProducts()
                    this.calcOrder()
                    this.setCheckedAll(false)
                }
            })
        }
    },
    components: {
        GnzsCheckbox
    }
}
</script>

<style lang="scss" module>
    @import './ProductsTable.scss';
</style>